export default {
  usage: 'Użycie',
  parameters: 'Parametry',
  body: 'Treść',
  bodyHint: 'Pozostaw treść pustą, aby użyć treści domyślnej. Zmieniona treść obowiązuje w każdym raporcie.',
  copyDefaultBody: 'Kopiuj treść domyślną',
  resetBody: 'Użyj treści domyślnej',
};
